/**
 * @generated SignedSource<<45773ae452320b3d7e43735520694d11>>
 * @relayHash 859c4519d9f6a5ca73cfce294568c2fe
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 859c4519d9f6a5ca73cfce294568c2fe

import { ConcreteRequest } from 'relay-runtime';
export type De_createInboundCallInput = {
  queryParameters: InboundCallQueryParametersInput;
  queryPath: string;
};
export type InboundCallQueryParametersInput = {
  callId?: string | null;
  callLine?: string | null;
  country?: string | null;
  lang?: string | null;
  phoneNumber?: string | null;
  pl?: string | null;
  record?: string | null;
};
export type useCallContextStoreDeCreateInboundCallMutation$variables = {
  input: De_createInboundCallInput;
};
export type useCallContextStoreDeCreateInboundCallMutation$data = {
  readonly de_createInboundCall: {
    readonly createInboundCallOutput: {
      readonly inboundCallId: number;
    } | null;
  };
};
export type useCallContextStoreDeCreateInboundCallMutation = {
  response: useCallContextStoreDeCreateInboundCallMutation$data;
  variables: useCallContextStoreDeCreateInboundCallMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "De_createInboundCallPayload",
    "kind": "LinkedField",
    "name": "de_createInboundCall",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CreateInboundCallOutput",
        "kind": "LinkedField",
        "name": "createInboundCallOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inboundCallId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCallContextStoreDeCreateInboundCallMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCallContextStoreDeCreateInboundCallMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "859c4519d9f6a5ca73cfce294568c2fe",
    "metadata": {},
    "name": "useCallContextStoreDeCreateInboundCallMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3938bba6f75c0aac57c846e6b2206041";

export default node;
